'use strict';

exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


//////////////////
// WEBPACK FOOTER
// /tw-build/dev/global-site/~/history/lib/ExecutionEnvironment.js
// module id = 27
// module chunks = 0